;( function( $, undefined )
{
    var manualCollapse = function()
    {
        $( '#topic-select-topics' ).addClass( 'collapsed' );
        $( '#theHero' ).addClass( 'collapsed' );
        $( '#toggle-pupular-topics' ).removeClass( 'open' );
    };

    $.fn.BrowseTopicsHead = function()
    {
        var $mainContainer = $( '#PDC6-main-container' );

        // is the current topic a "popular topic" ?
        if( $( '#topic-select-topics' ).find( '.current-topic' ).size() <= 0 && !$mainContainer.hasClass( 'layout-categorypage-maincategory' ) )
        {
            manualCollapse();
        }

        if( $mainContainer.hasClass( 'layout-categorypage-maincategory' ) && $mainContainer.data( 'top-category' ) == 'PSSdevforum' )
        {
            manualCollapse();
        }
    };

} )( jQuery );